'use strict';

const {fillWithShapeOptions} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('polygon', function () {
    const select = this.addShapeSelector(3, 20);
    const bounds = new Shape.Quadrilateral.Square(Point.origin(), this.width);
    bounds.setAnchorPoint(Point.origin());

    const draw = () => {
        this.wipe();
        let shape = new Shape(parseInt(select.value, 10), Point.origin(), 100);
        shape.scaleToFitWithin(this.width - this.pad * 2);
        shape.centerAgainst(bounds);
        shape.draw(this.ctx);
    };

    select.addEventListener('change', draw);
    draw();
});


